import classnames from 'classnames/bind'
import { BigNumber } from 'bignumber.js'

// Libs

// Components

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

interface TabItemProps {
  className?: string
  label: string
  isActive: boolean
  handleItemClick: () => void
  count?: number
}

const TabItem = (props: TabItemProps) => {
  const { className, label, isActive, handleItemClick, count = 0 } = props

  return (
    <div className={cx('tab-item', className)} data-is-active={isActive} onClick={handleItemClick}>
      <p>{label}</p>

      {count > 0 && (
        <div className={cx('tab-item-count')}>
          <p className={cx('tab-item-count-number')}>{new BigNumber(count).toFormat()}</p>
        </div>
      )}
    </div>
  )
}

export default TabItem
